import { useEffect, useRef, useState } from 'react';
import EditComponent from './CustomerServiceEdit';
import WebUniversal, { WUExtendPropsType } from '../../../system/WebUniversalNewEx'
import { columnsheadId } from '../../../universal/columnshead';
import dayjs from 'dayjs';
import { Button, Tooltip } from 'antd';
import CustomerServiceMessage from './CustomerServiceMessage';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';

/**
 * 组件 
 * @param props 
 * @returns 
 */
const Web = (props: any) => {
    const apiId = 'customerService';

    //刷新变量
    const [refresh, setRefresh] = useState(0);
    const [modalCustomerServiceMessage, setModalCustomerServiceMessage] = useState(false);
    const [customerServiceMessageData, setCustomerServiceMessageData] = useState<any>();

    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);
    /** 刷新数据 */
    let initData: any;
    /** 更改一项数据 */
    let handleChangeOne: any;
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initData = ref.current.initData;
            // eslint-disable-next-line react-hooks/exhaustive-deps
            handleChangeOne = ref.current.handleChangeOne;
        }
        // const fetchData = async () => {
        // };
        // fetchData();
        if (refresh !== 0) {
            initData();
        }
    }, [refresh]); //初始化数据

    /** 表头内容 */
    const columnsHead = [
        {
            title: 'wxOpenId',
            dataIndex: 'wxOpenId',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '客服使用者',
            dataIndex: 'customerServiceOperator',
            render: (text: any) => (
                text ? text.operatorName : ''
            )
        },
        {
            title: '接入',
            dataIndex: 'isAccess',
            render: (text: any) => (
                text === true ? '是' : '否'
            )
        },
        {
            title: '当前接入',
            dataIndex: 'currentAccessId',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '接入时间',
            dataIndex: 'accessDate',
            render: (text: any) =>
                <span>
                    {dayjs(text).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '离开时间',
            dataIndex: 'leaveDate',
            render: (text: any) =>
                <span>
                    {dayjs(text).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '信息',
            dataIndex: 'id',
            render: (text: any) => (<Button type='primary' onClick={
                () => {
                    setCustomerServiceMessageData({
                        customerServiceId: text
                    });
                    setModalCustomerServiceMessage(true);
                }
            }>信息</Button>)
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '客户服务',
        apiId,
        columns,
        showStates: true,
        EditComponent,
        serviceId: 'business',
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
            {modalCustomerServiceMessage ? (
                <AntDraggableModal
                    title={`客服信息`}
                    open={true}
                    okText='关闭'
                    cancelButtonProps={{ style: { display: "none" } }}
                    onOk={() => { setModalCustomerServiceMessage(false); }}
                    closable={false}
                    maskClosable={false}
                    width={1200}
                >
                    <CustomerServiceMessage data={customerServiceMessageData} />
                </AntDraggableModal>)
                : null}
        </>
    )
}

export default Web;